import React from 'react'
import { checkTextTranslation, imageAddress, pathMaker } from '../../utils/useful'
import TLink from '../TLink'

class TabelGlobalUserInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    init = () => {
        // console.log("TEST")
    }


    render() {
        if(this.props.data){
        return (
            
            <a href={pathMaker('/'+this.props.data.username)} target="_blank" className="w-100 h-100 flexc py-1" style={{ overflow: 'hidden' }}>
                <div className="flexcc">
                    <img src={imageAddress(this.props.data?.image, 'profile', 'small')} width="30px" style={{ border: '1px solid #eee', borderRadius: 50, height: 30, objectFit: 'cover' }} />
                </div>
                <div className="mld-2 w-100 " style={{ display: 'inline-block' }}>
                    <p className="text-small" style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{this.props.data?.fullname}</p>
                    <p className="text-smaller " style={{ width: '80%', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', color: '#789' }}>@{this.props.data?.username}</p>
                </div>
            </a>
        )
        }else{
            return (
            <div className="flexcc w-100 h-100">
                <p className="text-smaller " style={{color:'#789'}}>NO USER</p>
            </div>
            )
        }
    }
}

export default (TabelGlobalUserInput);